import { render, staticRenderFns } from "./BarTitleWithFb.vue?vue&type=template&id=8b1129c6&scoped=true&"
import script from "./BarTitleWithFb.vue?vue&type=script&lang=js&"
export * from "./BarTitleWithFb.vue?vue&type=script&lang=js&"
import style0 from "./BarTitleWithFb.vue?vue&type=style&index=0&id=8b1129c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1129c6",
  null
  
)

export default component.exports